import { connect } from 'react-redux'
import { MediaTitle } from './MediaTitle.jsx'
import { getCurrentMediaTitle } from 'redux/currentMedia/selectors'

export const mapStateToProps = (state, props) => ({
    title: getCurrentMediaTitle(state),
})

export const mapDispatchToProps = (dispatch, ownProps) => ({})

export const MediaTitleContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(MediaTitle)
